/**
 * @generated SignedSource<<9405cd63754ebc481a5812de6d435a58>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MilestoneKind = "CONVERSATIONS" | "FIRST_BOOK" | "FIRST_CONVERSATION" | "LESSON_SET" | "LONG_ANSWER" | "LONG_TALK" | "NEW_TUTOR" | "PATTERN_USED" | "WORDS" | "%future added value";
export type MomentsQuery$variables = Record<PropertyKey, never>;
export type MomentsQuery$data = {
  readonly me: {
    readonly learner: {
      readonly id: string;
      readonly milestones: ReadonlyArray<{
        readonly achievedAt: any;
        readonly detail: string | null | undefined;
        readonly kind: MilestoneKind;
      }>;
      readonly milestonesSeenAt: any | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MomentsQuery = {
  response: MomentsQuery$data;
  variables: MomentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "milestonesSeenAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Milestone",
            "kind": "LinkedField",
            "name": "milestones",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "detail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "achievedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MomentsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MomentsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "74284d4c1599aaa4995340cc4fae7eb2",
    "id": null,
    "metadata": {},
    "name": "MomentsQuery",
    "operationKind": "query",
    "text": "query MomentsQuery {\n  me {\n    learner {\n      id\n      milestonesSeenAt\n      milestones {\n        kind\n        detail\n        achievedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2596ef2daed4233f24d8e1caa6eea204";

export default node;
